import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { auth, db } from '../../firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { doc, getDoc } from 'firebase/firestore';
import { ROLE_ERROR_MESSAGES } from '../../utils/roles';

// Composant pour protéger l'accès aux routes avec vérification des rôles
const ProtectedRoute = ({ children, requiredRole }) => {
  const [user, loading] = useAuthState(auth);
  const [setUserRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);
  const [setError] = useState('');

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user && requiredRole) {
        try {
          const userDoc = await getDoc(doc(db, 'identifications', user.uid));
          if (userDoc.exists()) {
            const role = userDoc.data().role;
            setUserRole(role);
            
            // Vérifier si l'utilisateur a le bon rôle
            if (role !== requiredRole) {
              setError(ROLE_ERROR_MESSAGES[requiredRole] || 'Accès non autorisé');
            }
          } else {
            setError('Utilisateur non trouvé dans la base de données');
          }
        } catch (error) {
          console.error('Erreur lors de la récupération du rôle:', error);
          setError('Erreur lors de la vérification des permissions');
        } finally {
          setRoleLoading(false);
        }
      } else {
        setRoleLoading(false);
      }
    };

    fetchUserRole();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, requiredRole]);

  // Loading state
  if (loading || roleLoading) {
    return (
      <div className="loading-container">
        <div className="dot-spinner">
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
        </div>
        <p>Vérification des permissions...</p>
      </div>
    );
  }

  // Si l'utilisateur n'est pas connecté
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si tout est OK, afficher le contenu
  return children;
};

export default ProtectedRoute;
